export { FloatingZoomControls } from './FloatingZoomControls';
export type { FloatingZoomControlsProps } from './FloatingZoomControls';
